import { FC } from "react"
import { Drawer } from "antd"
import {
  XMarkIcon
} from "@heroicons/react/24/outline"
import { productName } from "./sportConfig"

type PrivacyDrawerProps = {
  isOpen: boolean
  onClose?: () => void
}
export const PrivacyDrawer: FC<PrivacyDrawerProps> = ({ isOpen, onClose }) => {
  return (
    <Drawer
      open={isOpen}
      title={'Privacy Policy'}
      closeIcon={
        <div style={{ width: '30px' }}>
          <XMarkIcon style={{ color: '#fff', height: '30px', width: '30px' }} fontSize={30} />
        </div>
      }
      size={'large'}
      onClose={() => onClose?.()}
      headerStyle={{
        background: '#000',
        color: '#fff',
        fontFamily: '"Space Grotesk", sans-serif'
      }}
      styles={{
        body: {
          background: '#000',
          fontFamily: '"Space Grotesk", sans-serif',
          color: '#fff'
        }
      }}
    >
      <div>
        
        <h3 dir="ltr">
          1. Introduction
        </h3>
        
        <p dir="ltr">
          This Privacy Policy aims to inform users about how we collect, manage, and
          protect personal data during the use of the application, {productName}.
          NYBE PLAY Limited Liability Company (registered office: 1183 Budapest, Alpár
          utca 24; tax number: 32713172-2-43), as the data controller, is committed to
          protecting users' data.
        </p>
        
        <h3 dir="ltr">
          2. Collected Data
        </h3>
        
        <p dir="ltr">
          During the use of the application, we may collect the following personal
          data:
        </p>
        <ul>
          <li dir="ltr">
            <p dir="ltr">
              Name
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Email address
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Address for invoicing
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Phone number (optional)
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              User settings
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Subscription information
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Cookies are used on the website in accordance with the relevant
              information provided in the Cookie Policy.
            </p>
          </li>
        </ul>
        
        <h3 dir="ltr">
          3. Purpose of Data Processing
        </h3>
        
        <p dir="ltr">
          The collected data will be used for the following purposes:
        </p>
        <ul>
          <li dir="ltr">
            <p dir="ltr">
              Ensuring the operation of the application
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Managing user accounts
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Providing subscription services
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Sending information about app updates and offers
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Billing for download and subscription fees
            </p>
          </li>
        </ul>
        
        <h3 dir="ltr">
          4. Legal Basis for Data Processing
        </h3>
        
        <p dir="ltr">
          The legal basis for processing personal data includes:
        </p>
        <ul>
          <li dir="ltr">
            <p dir="ltr">
              User consent
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Fulfillment of the subscription contract
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Compliance with legal obligations
            </p>
          </li>
        </ul>
        
        <h3 dir="ltr">
          5. Data Retention
        </h3>
        
        <p dir="ltr">
          We will retain personal data as long as necessary to achieve the above
          purposes or as required by law.
        </p>
        
        <h3 dir="ltr">
          6. Data Sharing
        </h3>
        
        <p dir="ltr">
          We do not share users' personal data with third parties, except when
          required by law, when requested by authorities in accordance with legal
          provisions, or if the user gives prior consent.
        </p>
        
        <h3 dir="ltr">
          7. Data Processors
        </h3>
        
        <p dir="ltr">
          The data controller engages the following data processors for the management
          of personal data. These data processors handle personal data in accordance
          with legal regulations and contractual obligations.
        </p>
        
        <div dir="ltr">
          <table>
            <colgroup>
              <col width="173"/>
              <col width="301"/>
              <col width="131"/>
            </colgroup>
            <tbody>
            <tr>
              <td>
                <p dir="ltr">
                  Data Processors
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Contact Information
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Activity
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  ARTEND CONSULTING Kft.
                </p>
              </td>
              <td>
                <p dir="ltr">
                  1112 Budapest, Péterhegyi lejtő 20. Phone:
                  06-1/789-5242, 06-20/9973-574, E-mail: info@artend.hu
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Accounting
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  Nagy Péter egyéni vállalkozó
                </p>
              </td>
              <td>
                <p dir="ltr">
                  6600 Szentes, Lapistó tanya 47/A.
                </p>
              </td>
              <td>
                <p dir="ltr">
                  programozás, fejlesztés
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  Billingo Technologies Zrt.
                </p>
              </td>
              <td>
                <p dir="ltr">
                  https://www.billingo.hu/
                </p>
                <p dir="ltr">
                  1133 Budapest, Árbóc utca 6. I. emelet
                </p>
                <p dir="ltr">
                  <a href="mailto:business@billingo.hu">
                    business@billingo.hu
                  </a>
                </p>
                <p dir="ltr">
                  +36-1-5009491
                </p>
              </td>
              <td>
                <p dir="ltr">
                  online számlázás
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  Amazon Web Services
                </p>
              </td>
              <td>
                <p dir="ltr">
                  <a href="https://aws.amazon.com/contact-us/">
                    https://aws.amazon.com/contact-us/
                  </a>
                </p>
              </td>
              <td>
                <p dir="ltr">
                  tárhely szolgáltatás
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  RevenueCat
                </p>
              </td>
              <td>
                <p dir="ltr">
                  <a href="https://www.revenuecat.com/contact/">
                    https://www.revenuecat.com/contact/
                  </a>
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Management of subscriptions and in-app purchases
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  Apple Inc.
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Web:
                  <a href="https://www.apple.com/legal/privacy/">
                    https://www.apple.com/legal/privacy/
                  </a>
                </p>
                <p dir="ltr">
                  Contact: Apple Support
                </p>
              </td>
              <td>
                <p dir="ltr">
                  App Store
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p dir="ltr">
                  Google LLC
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Web:
                  <a href="https://policies.google.com/privacy">
                    https://policies.google.com/privacy
                  </a>
                </p>
                <p dir="ltr">
                  Contact: Google Support
                </p>
              </td>
              <td>
                <p dir="ltr">
                  Google Play
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        
        <p dir="ltr">
          In addition to the above Data Processors, individuals who have an employment
          or contractual relationship with the Data Controller are entitled to access
          and process personal data. These individuals are required to handle the data
          confidentially, as they are bound by confidentiality obligations under their
          contracts with the Data Controller. This means that they cannot process the
          known data for purposes beyond their contractual relationship or disclose it
          to third parties. The tasks, access rights, and obligations of individuals
          involved in data processing are regulated by the Data Controller's internal
          policies and data processing agreements. Employees are liable under labor
          law, while contractual partners are liable under civil law for compliance
          with these obligations.
        </p>
        
        <h3 dir="ltr">
          8. User Rights
        </h3>
        
        <p dir="ltr">
          Users have the right to:
        </p>
        <ul>
          <li dir="ltr">
            <p dir="ltr">
              Access their personal data
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Request correction or deletion of their data
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Request restriction of data processing
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Object to data processing
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Exercise the right to data portability
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Request information regarding the processing of their data.
            </p>
          </li>
        </ul>
        
        <p dir="ltr">
          Right to Information
        </p>
        <p dir="ltr">
          The Data Controller is obliged to provide appropriate information in an
          understandable language, accessible (online or offline) regarding the
          essential aspects of data processing. At the time of data collection or upon
          the user's subsequent request for information, the Data Controller must
          provide the Privacy Policy and obtain a signed statement from the user
          confirming their understanding and acceptance of its contents.
        </p>
        
        <p dir="ltr">
          The Data Subject is entitled to request information about the personal data
          processed by the Data Controller at any time. Information can be requested
          via the designated email address in the information document, by post, or by
          phone. The Data Controller is required to provide the requested information
          within 30 days of the request.
        </p>
        
        
        <p dir="ltr">
          Right to Deletion
        </p>
        <p dir="ltr">
          The Data Subject has the right to request the Data Controller to delete
          their personal data without undue delay, and the Data Controller is obliged
          to delete the personal data concerning the Data Subject without undue delay.
          If the Data Controller has granted access to the requested data to third
          parties, they must inform all those to whom the personal data was disclosed
          to delete all references and personal data stored by them. The aim is to
          ensure that, unless there are legal or reasonable obstacles, the data
          "disappears" from available databases.
        </p>
        
        <p dir="ltr">
          Deletion does not have to be fulfilled if the data processing is necessary
          for:
        </p>
        <ul>
          <li dir="ltr">
            <p dir="ltr">
              Exercising freedom of expression or the right to information
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Legal claims and their enforcement or protection;
            </p>
          </li>
          <li dir="ltr">
            <p dir="ltr">
              Compliance with legal obligations;
            </p>
          </li>
        </ul>
        
        <p dir="ltr">
          Archiving in the public interest, scientific or historical research, or
          statistical purposes, where deletion would make it impossible or seriously
          jeopardize the achievement of the purpose of data processing.
        </p>
        
        <p dir="ltr">
          The Data Controller will also delete the personal data in its documentation
          concerning the Data Subject when the purpose of processing the personal data
          ceases.
        </p>
        
        <p dir="ltr">
          For paper-based documentation, destruction must be documented to ensure that
          the fact can be proven to the relevant authority in the future.
        </p>
        
        <p dir="ltr">
          Right to Correction
        </p>
        <p dir="ltr">
          The Data Subject may indicate that the processed data is inaccurate and
          request that it be replaced with accurate data. The Data Controller is
          responsible for the accuracy of the data, thus it is necessary to
          periodically verify their accuracy.
        </p>
        
        <p dir="ltr">
          Right to Restrict Processing
        </p>
        <p dir="ltr">
          The Data Subject may request the restriction of processing their personal
          data from the Data Controller, for example, in the event of an unclear legal
          dispute. If processing is restricted, such personal data may only be
          processed, except for storage, with the Data Subject's consent, for the
          establishment, exercise, or defense of legal claims, or for the protection
          of the rights of another natural or legal person, or for important public
          interests of the Union or a member state.
        </p>
        
        <p dir="ltr">
          Right to Data Portability
        </p>
        <p dir="ltr">
          The Data Subject may request that their processed data be provided in a
          structured, commonly used, machine-readable format (e.g., .doc, .pdf, etc.)
          and is entitled to transmit this data to another data controller without
          hindrance from the original data controller. This eases the situation of the
          data subject by allowing them to transfer their personal data from one data
          controller to another.
        </p>
        
        <p dir="ltr">
          Right to Object
        </p>
        <p dir="ltr">
          The Data Subject is entitled to object at any time to the processing of
          their personal data for specific reasons if they have not given their
          consent to the processing.
        </p>
        
        <p dir="ltr">
          If the Data Subject wishes to exercise their rights, this will involve
          identification, and the Data Controller must communicate with the Data
          Subject; therefore, personal data will need to be provided for
          identification (but the identification can only be based on data that we
          already process about you). Furthermore, your complaints regarding data
          processing will be accessible in our email inbox within the specified time
          frame mentioned in this information document.
        </p>
        
        <p dir="ltr">
          The Data Controller will respond to any complaints regarding data processing
          promptly, but no later than within 30 days.
        </p>
        
        <h3 dir="ltr">
          9. Data Security
        </h3>
        
        <p dir="ltr">
          The main platform for maintaining records of data is the Data Controller's
          IT system. The Data Controller stores the aforementioned personal data via
          its IT data processor.
        </p>
        
        <p dir="ltr">
          The Data Controller commits to ensuring data security in accordance with the
          provisions of the GDPR and the relevant Hungarian laws.
        </p>
        
        <p dir="ltr">
          During the operation of IT systems, necessary rights management, internal
          organizational, and technical solutions are provided to prevent unauthorized
          access to data, deletion, extraction from the system, or modification by
          unauthorized persons. The Data Controller enforces data protection and data
          security requirements with regard to data processors as well.
        </p>
        
        <p dir="ltr">
          The Data Controller maintains a record of any potential data protection
          incidents and will inform the Data Subject if necessary, and, if required,
          the National Authority for Data Protection and Freedom of Information
          (NAIH).
        </p>
        
        <p dir="ltr">
          Access to personal data is granted only to those individuals acting on
          behalf of the Data Controller—such as authorized representatives and
          employees—who require it to perform their duties and who are aware of their
          obligations regarding data processing.
        </p>
        
        <p dir="ltr">
          The Data Controller pays special attention to ensuring that all its
          authorized representatives and employees are familiar with its internal data
          protection protocols and conduct personal data processing in accordance with
          those protocols.
        </p>
        
        <p dir="ltr">
          The Data Controller commits to using the most advanced and appropriate
          equipment and security measures to ensure the security of the data,
          particularly to prevent unauthorized access, unlawful disclosure, deletion,
          or destruction of the data. The Data Controller will take all feasible steps
          to prevent accidental damage or destruction of the data. The Data Controller
          imposes this commitment on its employees involved in data processing
          activities.
        </p>
        
        <p dir="ltr">
          The Data Controller does not collect sensitive data under any circumstances,
          meaning data related to racial or ethnic origin, political opinions or
          affiliations, religious or other beliefs, trade union memberships, health
          conditions, addictions, sexual life, or criminal history.
        </p>
        
        <h3 dir="ltr">
          10. Contact
        </h3>
        
        <p dir="ltr">
          For any questions or requests, users can contact us at the following:
        </p>
        <p dir="ltr">
          Email: info@nybeplay.hu
        </p>
        <p dir="ltr">
          Head office: Hungary, 1183 Budapest, Alpár utca 24.
        </p>
        
        <h3 dir="ltr">
          11. Remedies
        </h3>
        
        <p dir="ltr">
          The Data Subject is entitled to file a complaint with the Data Protection
          Authority operating in Hungary, namely NAIH (1055 Budapest, Falk Miksa u.
          9-11; www.naih.hu, Phone: +36 (1) 391-1400, Fax: +36 (1) 391-1410, Email:
          ugyfelszolgalat@naih.hu) or to enforce their rights regarding personal data
          processing before a competent court in accordance with Act CXXX of 2016 on
          Civil Procedure.
        </p>
        
        <h3 dir="ltr">
          12. Final Provisions
        </h3>
        
        <p dir="ltr">
          This Privacy Policy may be modified at any time. Users will be notified of
          the modified version upon their next login. Please check this policy from
          time to time for the latest information.
        </p>
        <div>
          
        </div>
      </div>
    </Drawer>
  )
}